import cx from 'classnames';
import { useLocation, useNavigate } from 'react-router-dom';

import useTheme from 'contexts/ThemeProvider/useTheme';
import useMxCookies from 'modules/Authentication/hooks/useMxCookies';
import { APP_ROUTES } from 'routes/routePaths';

import testingConstants from '../../utils/testingConstants';

export type HeaderLogoVariant = 'dark' | 'primary';

export interface HeaderLogoProps {
  variant: HeaderLogoVariant;
  className?: string;
}

const HeaderLogo = ({ variant, className }: HeaderLogoProps) => {
  const { logo, logoContrast } = useTheme();
  const useContrastLogo = variant === 'dark' && logoContrast;
  const { src: logoSrc } = useContrastLogo ? logoContrast : logo;
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { mxLoggedIn } = useMxCookies();

  const isAuthPageUnauthenticated = pathname === APP_ROUTES.authRoot && !mxLoggedIn;

  const handleClick = () => {
    if (isAuthPageUnauthenticated) return;
    navigate('/');
  };

  return (
    <div className="inline-flex h-full items-center lg:flex-1">
      <img
        src={logoSrc}
        alt="logo"
        data-testid={testingConstants.meedioLogo}
        className={cx(
          'app-logo',
          { 'cursor-pointer': !isAuthPageUnauthenticated, 'cursor-default': isAuthPageUnauthenticated },
          className
        )}
        onClick={handleClick}
      />
    </div>
  );
};

export default HeaderLogo;
